import React from "react";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";

import IconButton from "@mui/material/IconButton";
import Badge from "@mui/material/Badge";

import Analytics, {PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";
import GroheSvgFilterIcon from "../groheNavigation/groheFilters/groheFiltersIcon";
import {setGroheFiltersOpened} from "../../../../actions/groheFunctions";


const GroheMobileFooterFiltersButton = (props) => {

  const {intl, filtersOpened, selectedFilters, setGroheFiltersOpened} = props;

  const filtersButtonClick = () => {
    Analytics.sendClickEvent(PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFiltersOpen);
    setGroheFiltersOpened(!filtersOpened);
  }

  return (
    <IconButton aria-label={intl.formatMessage({id:"iconButton.info"})}
                className={"gm-footer__menu look-icon look-button look-button--secondary look-button--no-radius"
                  + (filtersOpened ? " look-icon--active" : "")}
                onClick={filtersButtonClick}>
      <Badge badgeContent={selectedFilters.length} color="secondary" invisible={!selectedFilters.length}>
        <GroheSvgFilterIcon/>
      </Badge>
    </IconButton>
  )
};

const mapStateToProps = (store) => {
  const {selectedFilters} = store.filterState;
  const {filtersOpened} = store.groheState;

  return {
    selectedFilters,
    filtersOpened,
  };
};

const mapDispatchToProps = {
  setGroheFiltersOpened
};

export default (
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(GroheMobileFooterFiltersButton)
  )
);
